import { useState } from 'react'

import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { Button } from 'components/ui/Button/Button'
import { Slider } from 'components/ui/Slider/Slider'
import { DigitInput } from 'components/ui/Input/DigitInput'
import { WarehouseSearch } from 'components/WarehouseSearch/WarehouseSearch'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'
import { useContainersActions } from 'services/warehouse-containers/containers'
import { QrPaste } from 'components/QrPaste/QrPaste'
import { QrEntry } from 'components/QrPaste/types'

import './cargo.style.css'

export const CreateCargo = () => {
  const [entries, setEntries] = useState<QrEntry[]>([])
  const [isSliderActive, setIsSliderActive] = useState(false)
  const [orderNumber, setOrderNumber] = useState('')
  const [warehouse, setWarehouse] = useState<Warehouse | null>(null)
  const [formKey, setFormKey] = useState(0)

  const { createCargo, isLoading } = useContainersActions()

  const closeSlider = () => setIsSliderActive(false)

  const reset = () => {
    setEntries([])
    setOrderNumber('')
    setWarehouse(null)
    // NOTE: Вот это сильно смущает. Но не понятно как нам сбросить WarehoseSearch и при этом не
    // ререндерить всю страницу. У нас так везде и работает.
    setFormKey((key) => key + 1)
    closeSlider()
  }

  const handleCreate = async () => {
    if (!orderNumber || !warehouse) return

    const ok = await createCargo(
      Number(orderNumber),
      warehouse.id,
      entries.map((entry) => ({ containerId: entry.containerId, sealNumber: entry.seal }))
    )

    if (!ok) {
      closeSlider()

      return
    }

    reset()
  }

  return (
    <>
      <TitledContainer
        title="Создание груза"
        hint="Скопируйте изображение QR-кода в буфер, кликните в зону и вставьте."
      >
        <QrPaste entries={entries} onChange={setEntries} />
        <div className="create-cargo__submit-row">
          <Button
            title="Создать груз"
            disabled={
              entries.length === 0 || entries.some((entry) => !entry.containerId || !entry.seal)
            }
            handleOnSubmit={() => setIsSliderActive(true)}
          />
        </div>
      </TitledContainer>
      <Slider isActive={isSliderActive} onClose={closeSlider} height="360px">
        <div className="transfer-page-list__slider">
          <h2>Создание груза</h2>
          <div className="support-transfer__slider-target">
            <label className="create-cargo__field-label">Номер заказа</label>
            <DigitInput value={orderNumber} onChange={setOrderNumber} />
          </div>
          <div className="support-transfer__slider-target">
            <label className="create-cargo__field-label">Склад назначения</label>
            <WarehouseSearch
              key={formKey}
              onSelect={setWarehouse}
              searchForTypes={[WarehouseType.MiniWarehouse, WarehouseType.Courier]}
            />
          </div>
          <div className="transfer-page-list__slider-controlls">
            <span className="create-cargo__action-gap">
              <Button
                title="Создать"
                disabled={!orderNumber || !warehouse || isLoading}
                isLoading={isLoading}
                handleOnSubmit={handleCreate}
              />
            </span>
            <Button outline title="Отмена" handleOnSubmit={closeSlider} />
          </div>
        </div>
      </Slider>
    </>
  )
}
